import {ClauseTypeRegistration} from '@nh/angular-tses';
import {DASClauseType} from './das-clause-type';
import {DasSectionType} from './das-section-type';

export const DAS_CUSTOM_CLAUSE_TYPES: ClauseTypeRegistration[] = [
  {
    key: DASClauseType.HEADING,
    display: 'Heading',
    className: 'das-heading',
    sectionTypes: [DasSectionType.SUBMISSION_IN_PREPARATION, DasSectionType.SPECIALIST_COMMENTS]
  },
  {
    key: DASClauseType.SUB_HEADING,
    display: 'Sub-heading',
    className: 'das-sub-heading',
    sectionTypes: [DasSectionType.SUBMISSION_IN_PREPARATION, DasSectionType.SPECIALIST_COMMENTS]
  },
  {
    key: DASClauseType.NORMAL,
    display: 'Normal',
    className: 'das-normal',
    sectionTypes: [DasSectionType.SUBMISSION_IN_PREPARATION, DasSectionType.SPECIALIST_COMMENTS]
  }
];
